import { useCallback } from "react";
import { AssetConfig, assetConfig } from "./utilities/asset-config-option";
import { ChecksumAddress, ProtocolInstance, ProtocolKey } from "@silo/types";
import { isUndefined } from "lodash";
import { getConfigurationForAsset } from "./static/asset-config";

export const getStaticConfigForAssetForProtocolKey =
  (protocolKey: ProtocolKey): GetConfigurationForAsset =>
  (assetAddress) => {
    const config = getConfigurationForAsset(protocolKey, assetAddress);

    return config;
  };

/**
 * Returns protocol level asset configuration only!
 * In order to get asset configuration at the silo level, use useSiloConfiguration
 */
export const useAssetConfiguration = (
  protocolInstance: ProtocolInstance | undefined
) => {
  const staticConfiguration = useStaticAssetConfiguration(protocolInstance);

  return staticConfiguration;
};

export type GetConfigurationForAsset = (
  assetAddress: ChecksumAddress
) => AssetConfig;
export type AssetConfiguration = ReturnType<GetConfigurationForAsset>;

export const useStaticAssetConfiguration = (
  protocolInstance: ProtocolInstance | undefined
) => {
  const _getConfigurationForAsset: GetConfigurationForAsset = useCallback(
    (assetAddress) => {
      if (isUndefined(protocolInstance)) {
        return assetConfig.create({});
      }

      return getStaticConfigForAssetForProtocolKey(protocolInstance)(
        assetAddress
      );
    },
    [protocolInstance]
  );

  return {
    getConfigurationForAsset: _getConfigurationForAsset,
  };
};
